import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridMultirowModule } from "@grapecity/wijmo.angular2.grid.multirow";

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1500Component } from './kymw1500.component';
import { KYMW1501Module } from '../kymw1501/kymw1501.module';
import { KYMW1502Module } from '../kymw1502/kymw1502.module';
import { KYMW1503Module } from '../kymw1503/kymw1503.module';
import { KYMW1504Module } from '../kymw1504/kymw1504.module';
import { KYMW1505Module } from '../kymw1505/kymw1505.module';
import { KYMW1506Module } from '../kymw1506/kymw1506.module';
import { KYMW1507Module } from '../kymw1507/kymw1507.module';
import { KYMW1508Module } from '../kymw1508/kymw1508.module';
import { KYMW1509Module } from '../kymw1509/kymw1509.module';
import { KYMW1510Module } from '../kymw1510/kymw1510.module';

import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { GetMarkGroupListService } from './api-services/get-mark-group-list.service';
import { GetSupplyPromoteMarkDivListService } from './api-services/get-supply-promote-mark-div-list.service';
import { GetMarkFileService } from './api-services/get-mark-file.service';
import { UpdateMarkFileEnabledEventService } from './api-services/update-mark-file-enabled.service';
import { DeleteMarkFileService } from './api-services/delete-mark-file.service';
import { GetMarkImageDownloadService } from './api-services/get-mark-image-download.service';
import { UpdateMarkFilePeriodService } from './api-services/update-mark-file-period.service';
import { RegistMarkFilePeriodService } from './api-services/regist-mark-file-period.service';

import { GetCwsIconDataService } from './api-services/get-cws-icon-data.service';
import { DeleteCwsIconFileDataService } from './api-services/delete-cws-icon-file-data.service';

import { GetMarkConvInfoService } from './api-services/get-mark-conv-info.service';
import { GetCwsIconConvInfoService } from './api-services/get-cws-icon-conv-info.service';
import { UpdateCwsMarkConvService } from './api-services/update-cws-mark-conv.service';
import { UpdateCwsIconConvService } from './api-services/update-cws-icon-conv.service';


/**
 * マーク管理画面 モジュール設定クラス
 *
 * @export KYMW1500Module
 * @class KYMW1500Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
    WjGridMultirowModule,
    WjNavModule,
    WjInputModule,
    KYMW1501Module,
    KYMW1502Module,
    KYMW1503Module,
    KYMW1504Module,
    KYMW1505Module,
    KYMW1506Module,
    KYMW1507Module,
    KYMW1508Module,
    KYMW1509Module,
    KYMW1510Module,
  ],
  declarations: [
    KYMW1500Component,
  ],
  providers: [
    FileDownloadConfirmService,
    GetMarkGroupListService,
    GetSupplyPromoteMarkDivListService,
    GetMarkFileService,
    UpdateMarkFileEnabledEventService,
    DeleteMarkFileService,
    GetMarkImageDownloadService,
    UpdateMarkFilePeriodService,
    RegistMarkFilePeriodService,
    GetCwsIconDataService,
    DeleteCwsIconFileDataService,
    GetMarkConvInfoService,
    GetCwsIconConvInfoService,
    UpdateCwsMarkConvService,
    UpdateCwsIconConvService
  ],
})
export class KYMW1500Module {
}
